import React from 'react';
import PropTypes from 'prop-types';

import { Logo } from '@spotahome/ui-library';

const LogoLink = ({ link, color }) => (
  <a href={link}>
    <Logo color={color} size="medium" />
  </a>
);

LogoLink.propTypes = {
  link: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export default LogoLink;
